export const messageConstants = {
  NEW_ACTION_REQUEST: "NEW_ACTION_REQUEST",
  NEW_ACTION_SUCCESS: "NEW_ACTION_SUCCESS",
  NEW_ACTION_FAILURE: "NEW_ACTION_FAILURE",
};
